export default {
    /**
     * Detect if running in Electron.
     * @returns {boolean} process is running in Electron.
     */
    isElectron(): boolean {
        if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
            return true;
        }

        if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
            return true;
        }

        return !!window.ipcRenderer;
    }
};
